<template>
  <div>
    <!-- <task-filter @change="onChange" /> -->
    <a-card size="small" :loading="loading">
      <a-page-header title="研发工作实际产出">
        <!-- <template slot="extra">
          <noticeboard-push v-has="{ code: 'data:noticeboard:push' }" :source-id="sourceId" :source-data="data" />
        </template> -->
      </a-page-header>
      <a-tabs v-model="activeKey" size="small">
        <a-tab-pane key="1" tab="研发产出汇总表">
          <a-table size="small" :pagination="false" :columns="columns" row-key="index" :data-source="team_data" :loading="loading">
            <span slot="change_rate" slot-scope="text, record">
              <span :style="'color:' + record.color">{{ record.change_rate }}</span>
            </span>
          </a-table>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="研发任务完成详情">
          <work-info-detail-list style="float: left" :filter-form="filterForm" />
        </a-tab-pane>
        <a-tab-pane :key="3" tab="研发热力图" :force-render="true">
          <task-heat :filter-form="filterForm" />
        </a-tab-pane>
      </a-tabs>
    </a-card>
    <dev-task-trend :filter-form="filterForm" />
    <issue-solve-time :filter-form="filterForm" />
  </div>
</template>
<script>
import { getDevWorkChart } from '@/api/data/noticeboard';
import WorkInfoDetailList from '@/pages/data/components/WorkInfoDetailList.vue';
import TaskHeat from '@/pages/data/components/TaskHeat.vue';
import DevTaskTrend from '@/pages/data/components/DevTaskTrend.vue';
import IssueSolveTime from '@/pages/data/components/IssueSolveTime.vue';
const columns = [
  // {
  //   title: 'ID',
  //   dataIndex: 'id',
  //   key: 'id',
  //   width: '10%',
  //   ellipsis: true
  // },
  {
    title: '名称',
    dataIndex: 'team_name',
    key: 'team_name',
    width: '10%',
    ellipsis: true,
    scopedSlots: { customRender: 'team_name' }
  },
  {
    title: '总产出',
    dataIndex: 'total_point',
    key: 'total_point',
    width: '7%',
    sorter: (a, b) => a.total_point - b.total_point,
    ellipsis: true
  },
  {
    title: '总任务数',
    dataIndex: 'task_num',
    key: 'task_num',
    width: '7%',
    sorter: (a, b) => a.task_num - b.task_num,
    ellipsis: true
  },
  {
    title: '员工平均每日产出',
    dataIndex: 'average_point',
    key: 'average_point',
    sorter: (a, b) => a.average_point - b.average_point,
    width: '15%',
    ellipsis: true
  },

  {
    title: '代码行数',
    dataIndex: 'task_line',
    key: 'task_line',
    sorter: (a, b) => a.task_line - b.task_line,
    width: '15%',
    ellipsis: true
  },
  {
    title: '缺陷/千行代码',
    dataIndex: 'bugsPerTLine',
    key: 'bugsPerTLine',
    sorter: (a, b) => a.bugsPerTLine - b.bugsPerTLine,
    width: '15%',
    ellipsis: true
  },
  {
    title: '对比周期平均每日产出',
    dataIndex: 'last_average_point',
    key: 'last_average_point',
    sorter: (a, b) => a.last_average_point - b.last_average_point,
    width: '15%',
    ellipsis: true
  },
  {
    title: '三日无任务数',
    dataIndex: 'betweens',
    key: 'betweens',
    width: '10%',
    sorter: (a, b) => a.betweens - b.betweens,
    ellipsis: true
  },
  {
    title: '产生缺陷',
    dataIndex: 'bugs',
    key: 'bugs',
    width: '10%',
    sorter: (a, b) => a.bugs - b.bugs,
    ellipsis: true
  },
  {
    title: '缺陷/任务点',
    dataIndex: 'bugsPerPoint',
    key: 'bugsPerPoint',
    sorter: (a, b) => a.bugsPerPoint - b.bugsPerPoint,
    width: '10%',
    ellipsis: true
  },
  {
    title: '变化趋势',
    dataIndex: 'change_rate',
    key: 'change_rate',
    width: '10%',
    ellipsis: true,
    scopedSlots: { customRender: 'change_rate' }
  },
  {
    title: '请假',
    dataIndex: 'vacations',
    key: 'vacations',
    width: '5%',
    ellipsis: true
  },
  {
    title: '加班',
    dataIndex: 'out_works',
    key: 'out_works',
    width: '5%',
    ellipsis: true
  },
  {
    title: '非工作日',
    dataIndex: 'holidays',
    key: 'holidays',
    width: '7%',
    ellipsis: true
  },
  {
    title: '总天数',
    dataIndex: 'days',
    key: 'days',
    width: '5%',
    ellipsis: true
  },
  {
    title: '团队规模',
    dataIndex: 'team_length',
    key: 'team_length',
    width: '7%',
    ellipsis: true
  }
];
export default {
  components: { WorkInfoDetailList, TaskHeat, DevTaskTrend, IssueSolveTime },
  props: {
    sourceId: {
      type: [String, Number],
      default: null
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      columns,
      loading: false,
      visible: false,
      activeKey: '1',
      data: {
        title: null,
        projects: [],
        start_date: null,
        end_date: null,
        description: null,
        params: {}
      },
      formData: {},
      team_data: [],
      correctionData: []
    };
  },
  watch: {
    filterForm() {
      this.getDiagramData();
    }
  },
  created() {
    this.getDiagramData();
  },
  methods: {
    getDiagramData() {
      getDevWorkChart({ ...this.filterForm }).then(res => {
        this.team_data = res.data;
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .ant-table-tbody > tr > td > p {
  padding: 8px;
  border-bottom: 1px solid #e8e8e8;
  line-height: 20px;
  margin: 0 -8px;
}

/deep/ .ant-table-tbody > tr > td > p:last-child {
  margin-bottom: -12px;
  border: 0;
}

/deep/ .ant-table-tbody > tr > td > p:first-child {
  margin-top: -8px;
}
/deep/.ant-page-header {
  padding: 0;
}

/deep/.ant-tabs-bar {
  margin: 0 0 12px 0;
}
</style>
